module.exports = __webpack_public_path__ + "static/media/8902_LivingRoom.b5953d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8902_LivingRoom.jpg
// module id = 584
// module chunks = 0